import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceNewsletter {
    lookupService = new APIServiceLookUp();

    async getAllSubscription(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}newsletter/getAllSubscription`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateSubscription(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}newsletter/updateSubscription`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async delSubscription(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}newsletter/delSubscription`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}